const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/defs/types.ts';
import Imm from 'immutable';

import type { JSX } from "react";

export type Plan = {
    name: string;
    label: string;
    Icode: string;
    value: string;
    treatmentReasons: TreatmentReasonListItem[];
};

export type Slot = {
    id: string;
    startDate: string;
    endDate: string;
    schedule: string;
};

export type TreatmentReasonListItem = {
    fkey: string;
    name: string;
    duration?: number;
};

export enum SlotDuration {
    minutes = 'minutes',
    hours = 'hours',
    days = 'days',
}

export type Step = {
    title: string;
    text?: string;
    content: JSX.Element;
    condition: boolean;
    disabled: boolean;
};

export type NotLinkedPatient = Imm.Map<string, Imm.Set<string>>;

export type MetaKatTranslationSupportedLanguage = 'DE' | 'FR' | 'IT' | 'EN';

export type MetaKatTranslations = {
    [key in MetaKatTranslationSupportedLanguage]?: string;
};
